import { useEffect, useMemo } from "react";
import { convertSecondsToDurationString } from "../utils/time";
import { PlannedPhase } from "../pages/Room";

export interface UseUpdateTilteProps {
    currentPhase?: PlannedPhase, 
    timeUntilUpcomingSession?: number, 
    inside: boolean, 
    roomName: string
}

/**
 * Wrapper around a ``useEffect()`` that updates the title of the page
 * - both this page and a parent page that loads this page via an iframe and listens to the message
 */
export const useUpdateTitle = ({inside, roomName, timeUntilUpcomingSession, currentPhase}: UseUpdateTilteProps) => {
    
    const letParentDisplayTitle = true;

    const title = useMemo(() => {
        if (inside) {
            if (currentPhase) {
                // e.g. "4:40 🔊 Einstimmen"
                //      "25:13 🖊️ Fokus"
                // const emoji = currentPhase.audio ? "🔊" : "🖊️";
                // return `${convertSecondsToDurationString(currentPhase.duration)} ${emoji} ${currentPhase.name}`;
                return `${convertSecondsToDurationString(currentPhase.remainingTime ?? currentPhase.duration)} ${currentPhase.name}`;
            } else if (timeUntilUpcomingSession) {
                // e.g. "4:40 🍵 Pause"
                // return `${convertSecondsToDurationString(timeUntilUpcomingSession)} 🍵 Pause`;
                return `${convertSecondsToDurationString(timeUntilUpcomingSession)} Pause`;
            } else {
                return roomName;
            }
        } else {
            return roomName;     //if outside: only show room name - and don't push to parent
        }
    }, [inside, currentPhase, timeUntilUpcomingSession, roomName]);
    
    useEffect(() => {
        // console.log("useUpdateTitle: ", title, letParentDisplayTitle);
        document.title = title;
        if (letParentDisplayTitle) {
            window.parent.postMessage({ title, useTitle: true, inside }, "*");
        } else {
            window.parent.postMessage({ title, useTitle: false, inside }, "*");
        }
    }, [title, letParentDisplayTitle, inside]);

    //clear parent title when unmounting
    useEffect(() => {
        return () => {
            window.parent.postMessage({ useTitle: false }, "*");
        }
    }, []);
}